import React, { ReactNode } from 'react';
import { CommercialFormInterface } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';
import StepOne from './StepOne';
import { StepTwo } from './StepTwo';
import StepThree from './StepThree';
import FormFooter from '../../../common/FormFooter';

export const CommercialMobileForm = ({
    error,
    updateField,
    payload,
    corporatePartners,
    countries,
    isCountriesLoading,
    loadingCorporatepartners,
    setShowAddPartner,
    errors,
    quoteFields,
    updateQuoteField,
    removeQuoteField,
    currencies,
    addQuoteField,
    loadingCurrencies,
    setSignatureUrlBase64,
    signatureUrlBase64,
    totalAmount,
    setPartnerId,
    activeStep,
    setActiveStep,
    onSaveOnlyAction,
    showPreview,
    setShowPreview
}: CommercialFormInterface) => {
    const views: {
        [key: number]: ReactNode;
    } = {
        0: (
            <StepOne
                {...{
                    updateField,
                    payload,
                    corporatePartners,
                    errors,
                    loadingCorporatepartners,
                    setShowAddPartner
                }}
            />
        ),
        1: (
            <StepTwo
                {...{
                    updateField,
                    payload,
                    countries,
                    isCountriesLoading,
                    errors,
                    setShowAddPartner
                }}
            />
        ),
        2: (
            <StepThree
                {...{
                    updateField,
                    payload,
                    setPartnerId,
                    setShowAddPartner,
                    errors,
                    setSignatureUrlBase64,
                    signatureUrlBase64,
                    updateQuoteField,
                    removeQuoteField,
                    quoteFields,
                    addQuoteField,
                    totalAmount,
                    loadingCurrencies,
                    currencies,
                    onSaveOnlyAction,
                    showPreview,
                    setShowPreview
                }}
            />
        )
    };
    return (
        <div className='lg:hidden pt-4'>
            {views[activeStep ?? 0]}
            <FormFooter
                onContinue={() => {
                    setActiveStep(activeStep + 1);
                }}
                onSave={() => onSaveOnlyAction && onSaveOnlyAction()}
                onPreview={() => setShowPreview(!showPreview)}
                onGoBack={() => {
                    setActiveStep(activeStep - 1);
                }}
                steps={3}
                activeStep={activeStep}
                disabled={Object.values(payload).some(
                    (item) => item === undefined
                )}
            />
        </div>
    );
};
